
import { defineComponent } from 'vue';
import AdImage from '@/ad/components/AdImage.vue';
import AdListItemParams from '@/ad/components/AdListItemParams.vue';
import AdListItemPrice from '@/ad/components/AdListItemPrice.vue';
import { urlJoin } from '@/shared/helpers/urlJoin';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdInfoWindow',
  components: {
    AdImage,
    AdListItemParams,
    AdListItemPrice,
  },
  data() {
    return {
      detailUrl: urlJoin(window.location.origin, config.FRONT_RELATIVE_APP_URL, '/detail/'),
    };
  },
  props: {
    ad: Object,
  },
  computed: {
    ads() {
      const ad = (this as any).ad;
      return ad.items && ad.items.length ? ad.items : [ad];
    },
  },
});
